import axios from "../axiosInstance";

const inventoryAPI = {
  list: (params) => axios.get("/inventory", { params }),

  getAlerts: (params) => axios.get("/inventory/alerts", { params }),

  getMovements: (params) => axios.get("/inventory/movements", { params }),

  searchProducts: (params) => axios.get("/inventory/search", { params }),

  getLocations: () => axios.get("/inventory/locations"),

  adjust: (payload) => axios.post("/inventory/adjustments", payload),
};

export default inventoryAPI;
